import { render, staticRenderFns } from "./CMCourses.vue?vue&type=template&id=1390ee22&scoped=true&lang=pug&"
import script from "./CMCourses.vue?vue&type=script&lang=js&"
export * from "./CMCourses.vue?vue&type=script&lang=js&"
import style0 from "./CMCourses.vue?vue&type=style&index=0&id=1390ee22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1390ee22",
  null
  
)

export default component.exports